var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { staticClass: "map-locations__locations" },
    _vm._l(
      _vm.sortedLocations,
      function ({ name, address, postcode, tel, distance }, key) {
        return _c("div", { key: key, staticClass: "map-locations__location" }, [
          _c("div", { staticClass: "map-locations__name" }, [
            _vm._v("\n      " + _vm._s(name) + "\n      "),
            distance
              ? _c("span", { staticClass: "map-locations__distance" }, [
                  _vm._v(_vm._s(distance) + " Miles"),
                ])
              : _vm._e(),
          ]),
          _vm._v(" "),
          _c("div", { staticClass: "map-locations__description" }, [
            _vm._v("\n      " + _vm._s(address) + ",\n      "),
            _c("span", { staticClass: "map-locations__postcode" }, [
              _vm._v(_vm._s(postcode)),
            ]),
            _vm._v("\n      | " + _vm._s(tel) + "\n    "),
          ]),
        ])
      }
    ),
    0
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }